import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { LeaderGenerator } from '../../../../lib/leaderGenerator';
import { ReportsService } from '../../../../services/reports.service';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';
import { PayoutConfig } from '../../../../model/payoutConfig';

@Component({
    selector: 'page-cattle-report',
    templateUrl: 'report-cattle.html'

})
export class CattleReport {
    @Input('rodeo') rodeo: Rodeo;

    blankSchedule: RodeoEventSchedule = new RodeoEventSchedule();
    selectedRodeoEvent: RodeoEvent;
    selectedSchedule: RodeoEventSchedule;
    selectedMode: PayoutConfig;

    resultModes: PayoutConfig[] = [];

    dArray: number[] = [];
    dCount: number = 0;
    showTotal: boolean; 
    totalCattleCount: number = 0;

    documentTitle: any;

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    roundArray: any[];
    selectedRound: number;

    leaders: any[];
    totalPayout: number;

    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();

    constructor(private nav: NavController, navParams: NavParams, private reportService: ReportsService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');
        this.selectedSchedule = navParams.get('selectedSchedule');
        this.selectedMode = navParams.get('selectedMode');
        this.dCount = navParams.get('dCount');

        if (!this.selectedSchedule)
            this.selectedSchedule = this.blankSchedule;

        this.printing = navParams.get('print');

        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        this.updateRodeoEvent();

        this.roundArray = [];
        var maxRounds = this.selectedRodeoEvent.rounds;

        for (let i = 1; i <= maxRounds; i++) {
            this.roundArray.push(i);
        }

        this.selectedRound = this.roundArray[0];

        this.documentTitle = this.rodeo.name + " - " + 'Results';
        this.dataLoaded = true;
    }

    getCattleCount(schedule, round) {
        return schedule.runs.filter(x => x.round == round && !x.turnedOut && x.done).length;
    }

    updateRodeoEvent() {
        this.leaders = [];
        if (!this.selectedRodeoEvent)
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];

        this.totalCattleCount = this.selectedRodeoEvent.schedules.flatMap(x => x.runs).filter(x => !x.turnedOut && x.done).length;
        this.totalPayout = 0;

        setTimeout(() => {
            this.updateResultModes();

            if (this.selectedRodeoEvent.schedules.length == 1)
                this.selectedSchedule = null;

            if (this.selectedMode == null)
                return;

            this.showTotal = this.selectedMode.isAggregate || this.selectedMode.isAverage;

            this.leaders = LeaderGenerator.instance().getLeaders(this.rodeo, this.selectedMode, 9999, true, true, this.selectedRodeoEvent.fallBackToPlace)

            var winnersToMatch = this.selectedRodeoEvent.winners;

            this.leaders.forEach(group => {
                group.payout = 0;
                group.runs.forEach(run => {
                    run.winner = null;
                    
                    var matchingWinners = winnersToMatch.filter(x =>
                        x.name.toLocaleLowerCase().startsWith((this.selectedSchedule ? `Schedule ${this.selectedSchedule.name} ` + group.name: group.name).toLocaleLowerCase())
                        && (x.contestantOne ? x.contestantOne.id == run.contestantOneId : true)
                        && (x.contestantTwo ? x.contestantTwo.id == run.contestantTwoId : true)
                        && (x.horseOne ? x.horseOne.id == run.horseOneId : true)
                        && (x.horseTwo ? x.horseTwo.id == run.horseTwoId : true));

                    if (this.selectedMode.name == 'Teams') {
                        matchingWinners = this.selectedRodeoEvent.winners.filter(x =>
                            x.name.toLocaleLowerCase().startsWith((this.selectedSchedule ? `Schedule ${this.selectedSchedule.name} ` + group.name: group.name).toLocaleLowerCase())
                            && ((x.contestantOne ? x.contestantOne.id == run.contestantOneId : true)
                            || (run.contestantTwo ? x.contestantOne.id == run.contestantTwoId : true))
                            && ((x.horseOne ? x.horseOne.id == run.horseOneId : true)
                            || (run.horseTwo ? x.horseOne.id == run.horseTwoId : true)));
                    }

                    if (matchingWinners.length > 0) {
                        winnersToMatch = winnersToMatch.filter(x => x != matchingWinners[0]);
                        run.winner = JSON.parse(JSON.stringify(matchingWinners[0]));
                        
                        if (this.selectedMode.name == 'Teams') {
                            run.winner.payout *= 2;
                        }

                        group.payout += run.winner.payout;
                    }
                });

                this.totalPayout += group.payout;
            });
        }, 0);
    }

    updateResultModes() {
        this.resultModes = this.rodeo.payoutConfigs.filter(x => x.sources.some(y => y.rodeoEventId == this.selectedRodeoEvent.id && (!y.scheduleId || y.scheduleId == this.selectedSchedule.id)));

        if (!this.selectedMode || !this.resultModes.some(x => x.name.toLocaleLowerCase() == this.selectedMode.name.toLocaleLowerCase()))
            this.selectedMode = this.resultModes[0];
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    matchSchedules(a, b) {
        return !a.id && !b.id || a.id == b.id;
    }

    matchSelections(a, b) {
        return a.name == b.name;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(CattleReport, {
            rodeo: this.rodeo,
            print: true,
            selectedRodeoEvent: this.selectedRodeoEvent,
            selectedSchedule: this.selectedSchedule,
            selectedMode: this.selectedMode,
            dCount: this.dCount
        }).then(() => { this.popoverActive = false; });
    }

    download() {
        const report = [];
        this.leaders.forEach(group => {
            let i = 1;
            group.runs.forEach(run => {
                const runObj = {
                    Category: group.name,
                    Place: i++,
                    Run: run.number,
                    Name: `${run.contestantOne.firstName} ${run.contestantOne.lastName}`
                } as any;
                if (this.selectedRodeoEvent.eventType == 'BarrelRacing') {
                    runObj.Horse = run.horseOne != null ? run.horseOne.name : 'Horse 1';
                    runObj.Time = 0;
                } else if (this.isRoughStock(this.selectedRodeoEvent)) {
                    runObj.Stock = run.livestock != null ? run.livestock.brand + ' ' + run.livestock.name : 'Livestock 1';
                    runObj.Score = 0;
                } else {
                    runObj.Stock = run.livestock != null ? run.livestock.brand + ' ' + run.livestock.name : 'Livestock 1';
                    runObj.Time = 0;
                }

                runObj.Payout = run.winner ? run.winner.payout : '';

                report.push(runObj);
            });
        });

        this.reportService.exportToCsv(report, `${this.rodeo.name} - ${this.selectedRodeoEvent.displayName} - ${this.selectedMode}`);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-cattle.ts